export default "__VITE_ASSET__BFKyqXl6__"